module.exports = __webpack_public_path__ + "img/gamma3ex_icon.a9af556b.png";